import { render, staticRenderFns } from "./AdminInvoiceBillingInfoTable.vue?vue&type=template&id=1d96960a&"
import script from "./AdminInvoiceBillingInfoTable.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceBillingInfoTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports